/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FormQualitySubmissionDto } from '../../models/form-quality-submission-dto';

export interface ListFormQualitySubmissions$Params {
  profileId: string;
}

export function listFormQualitySubmissions(
  http: HttpClient,
  rootUrl: string,
  params: ListFormQualitySubmissions$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<FormQualitySubmissionDto>>> {
  const rb = new RequestBuilder(rootUrl, listFormQualitySubmissions.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FormQualitySubmissionDto>>;
    })
  );
}

listFormQualitySubmissions.PATH = '/forms/submissions/{profileId}/quality';
